import { REVIEWER_PERMISSIONS } from 'v2/utils/permissions';
import { useHasAnyPermission } from './useHasAnyPermission';

export function useIsReviewerUser(): boolean {
  return useHasAnyPermission(REVIEWER_PERMISSIONS);
}
